var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLossRate = function SvgLossRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B620E0",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M16 8a8 8 0 1 0 0 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8a8 8 0 1 1 0 16z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M16 20.8h-6M16 17.6H8.4M16 14.4H8.4M16 11.2h-6"
  })))));
};
export default SvgLossRate;